// extracted by mini-css-extract-plugin
export default {"IframeWriteComment":"IframeWriteComment--w7zFG","textarea-large":"textarea-large--UcBu0","textarea-small":"textarea-small--GNS47","send-btn":"send-btn--WgQZ_"};